import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiKeyQueryKeys, APIKeys } from '#api';

export function useDeleteAPIKeyMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (apiKeyID: string) => APIKeys.deleteAPIKey(apiKeyID),
    onSuccess: (data, apiKeyID) => {
      queryClient.removeQueries({ queryKey: apiKeyQueryKeys.detail(apiKeyID), exact: true });
      void queryClient.invalidateQueries({ queryKey: apiKeyQueryKeys.lists() });
    },
  });
}
